import useTaxes from '@/stores/taxes'

export default [
  {
    path: '/taxes/:tid',
    name: 'Taxes',
    component: () => import('@/views/taxes/index.vue'),
    beforeEnter: async (to, from) => {
      if (from.path === '/') {
        const taxesStore = useTaxes()
        const { info } = storeToRefs(taxesStore)
        const { setTid, setExtraQuery, resetInfo } = taxesStore
        setTid(to.params.tid)
        setExtraQuery(to.query)
        try {
          await resetInfo()
          if (info.value.validCellphone) {
            return { path: '/taxes/verify' }
          }
        } catch (err) {
          //  取消导航且继续向上传递错误，否则封装的请求捕获不到错误信息
          return Promise.reject(err)
        }
      }
    }
  },
  {
    path: '/taxes/verify',
    name: 'Verify',
    component: () => import('@/views/taxes/verify.vue')
  }
]
